import ipRegex from './ipRegex';

/**
 * @link https://github.com/silverwind/cidr-regex
 */
type CidrRegexOptions = {
  /**
  Only match an exact string. Useful with `RegExp#test()` to check if a string is an IP address. *(`false` matches any IP address in a string)*

  @defaultValue false
  */
  readonly exact?: boolean;
};

const v4str = `${ipRegex.v4().source}\\/(3[0-2]|[12]?[0-9])`;
const v6str = `${ipRegex.v6().source}\\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])`;

// pre-compile only the exact regexes as global flag makes regex objects stateful
const v46Exact = new RegExp(`(?:^${v4str}$)|(?:^${v6str}$)`);
const v4exact = new RegExp(`^${v4str}$`);
const v6exact = new RegExp(`^${v6str}$`);

const cidrRegex = (options?: CidrRegexOptions): RegExp =>
  options?.exact ? v46Exact : new RegExp(`(?:${v4str})|(?:${v6str})`, 'g');

cidrRegex.v4 = (options?: CidrRegexOptions): RegExp =>
  options?.exact ? v4exact : new RegExp(v4str, 'g');

cidrRegex.v6 = (options?: CidrRegexOptions): RegExp =>
  options?.exact ? v6exact : new RegExp(v6str, 'g');

export default cidrRegex;
